<template>
  <div>
      <div class="bodyWrap">
         <header>
              <div class="headTop">
                  <div class="topBox">
                       <div class="headLeft fl">
                        <span>时间：2021年3月31日</span>
                        <span>星期三</span>
                      </div>
                      <div class="headRig fr">
                  <router-link  to="/login" tag="span">登录</router-link>
                           <router-link to="/register" tag="span">注册</router-link>
                      </div>
                  </div>
              </div>
              <div class="headBottom">
                 <div class="bottomBox">
                    <div class="botLeft fl">
                    <img src="../../assets/img/show/logo.png" alt="">
                  </div>
                  <div class="botdRig fr">
                    <ul class="fl headUl">
                      <li>资源管理</li>
                      <li>统计分析</li>
                      <li>返回信息网</li>
                    </ul>
                    <div class="fr headSearch">
                          <el-input v-model="input" placeholder="发现数据从这里开始"></el-input>
                          <span>
                              <img src="../../assets/img/show/search.png" alt="">
                          </span>
                    </div>
                  </div>
                 </div>
              </div>
          </header>
           <div class="banner"> 
                <img src="../../assets/img/show/banner.png" alt="">
          </div>
          <div class="main">     
            <div class="tabZujian">
                    <div class="title">
                        <p>当前位置：首页 > 资源分类</p>
                    </div>
                    <div class="content1 clearfix">
                        <div class="contentLeft">
                            <h2>资源类型</h2>
                            <ul>
                              <li>热带香辛饮料作物（524）</li>
                              <li>热带经济作物（281）</li>
                              <li>热带油料作物（274）</li>
                              <li>热带南药植物（269）</li>
                              <li>热带特色蔬菜（132）</li>
                              <li>热带牧草（56）</li>
                              <li>热带果树（14）</li>
                              <li>热带粮食作物（675）</li>
                              <li>产胶作物（381）</li>
                            </ul>
                        </div>
                         <div class="rigBox fr">
                            <div class="rigBox1">
                                  <el-input v-model="input" placeholder="请输入您要检索的数据资源"></el-input>
                                  <div class="searchBtn">
                                    <button>搜 索</button>
                                  </div>
                             </div>
                              <nav>
                                   <ul>
                                     <li>
                                      <span>按种质类型：</span>
                                      <div>
                                         <span>选育品种</span>
                                          <span>选育品种</span>
                                          <span>选育品种</span>
                                          <span>选育品种</span>
                                          <span>选育品种</span>
                                          <span>选育品种</span>
                                          <span>选育品种</span>
                                          <span>选育品种</span>
                                      </div>
                                     </li>
                                     <li>
                                       <span>按地域：</span>
                                        <div>
                                       <span>湖南</span>
                                      <span>云南</span>
                                      <span>湖南</span>
                                      <span>湖南</span>
                                      <span>湖南</span>
                                      <span>湖南</span>
                                       </div>
                                     </li>
                                     <li>
                                        <span>按用途：</span>
                                         <div>
                                        <span>乡村振兴</span>
                                        <span>一带一路</span>
                                        <span>科技创新</span>
                                        <span>其他</span>
                                         </div>
                                     </li>
                                     <li>
                                       <span>按所在圃库：</span>
                                        <div>
                                       <span>儋州橡胶树种质资源圃</span>
                                       <span>儋州木薯种质资源圃</span>
                                       <span>瑞丽咖啡种质资源圃</span>
                                       <span>广州番木瓜种质资源圃</span>
                                       <span>儋州芒果种质资源圃</span>
                                       <span>湛江菠萝种质资源圃</span>
                                       <span>广州黄皮种质资源圃</span>
                                       <span>海口菠萝蜜种质资源圃</span>
                                        </div>
                                     </li>
                                     <li>
                                       <span>按发布时间：</span>
                                        <div>
                                       <span>2013年</span>
                                       <span>2014年</span>
                                       <span>2015年</span>
                                       <span>2016年</span>
                                       <span>2017年</span>
                                       <span>2018年</span>
                                       <span>2019年</span>
                                       <span>2020年</span>
                                      <span>2021年</span>
                                      </div>
                                     </li>
                                   </ul>
                              </nav>  
                            <div class="rigBox2">
                               <h2>共 <span>112</span> 条资源</h2>
                               <ul class="perUl">
                                  <li>
                                     <div class="perFirst">
                                         <strong>RO/JP/3 22/52s</strong>
                                         <span>发布时间：2021-06-21</span>
                                     </div>
                                     <div class="perLast">
                                       <p>所在圃库：<span>儋州橡胶树种质资源圃</span></p>
                                       <p>该种质资源为大戟科（Euphobiaceae）橡胶树属，来源巴西亚马逊河，资源种质类型属于野生资源。</p>
                                     </div>
                                  </li>
                                   <li>
                                     <div class="perFirst">
                                         <strong>RO/JP/3 22/52s</strong>
                                         <span>发布时间：2021-06-21</span>
                                     </div>
                                     <div class="perLast">
                                       <p>所在圃库：<span>儋州橡胶树种质资源圃</span></p>
                                       <p>该种质资源为大戟科（Euphobiaceae）橡胶树属，来源巴西亚马逊河，资源种质类型属于野生资源。</p>
                                     </div>
                                  </li>
                                   <li>
                                     <div class="perFirst">
                                         <strong>RO/JP/3 22/52s</strong>
                                         <span>发布时间：2021-06-21</span>
                                     </div>
                                     <div class="perLast">
                                       <p>所在圃库：<span>儋州橡胶树种质资源圃</span></p>
                                       <p>该种质资源为大戟科（Euphobiaceae）橡胶树属，来源巴西亚马逊河，资源种质类型属于野生资源。</p>
                                     </div>
                                  </li>
                                   <li>
                                     <div class="perFirst">
                                         <strong>RO/JP/3 22/52s</strong>
                                         <span>发布时间：2021-06-21</span>
                                     </div>
                                     <div class="perLast">
                                       <p>所在圃库：<span>儋州橡胶树种质资源圃</span></p>
                                       <p>该种质资源为大戟科（Euphobiaceae）橡胶树属，来源巴西亚马逊河，资源种质类型属于野生资源。</p>
                                     </div>
                                  </li>
                                   <li>
                                     <div class="perFirst">
                                         <strong>RO/JP/3 22/52s</strong>
                                         <span>发布时间：2021-06-21</span>
                                     </div>
                                     <div class="perLast">
                                       <p>所在圃库：<span>儋州橡胶树种质资源圃</span></p>
                                       <p>该种质资源为大戟科（Euphobiaceae）橡胶树属，来源巴西亚马逊河，资源种质类型属于野生资源。</p>
                                     </div>
                                  </li>
                                   <li>
                                     <div class="perFirst">
                                         <strong>RO/JP/3 22/52s</strong>
                                         <span>发布时间：2021-06-21</span>
                                     </div>
                                     <div class="perLast">
                                       <p>所在圃库：<span>儋州橡胶树种质资源圃</span></p>
                                       <p>该种质资源为大戟科（Euphobiaceae）橡胶树属，来源巴西亚马逊河，资源种质类型属于野生资源。</p>
                                     </div>
                                  </li>
                                   <li>
                                     <div class="perFirst">
                                         <strong>RO/JP/3 22/52s</strong>
                                         <span>发布时间：2021-06-21</span>
                                     </div>
                                     <div class="perLast">
                                       <p>所在圃库：<span>儋州橡胶树种质资源圃</span></p>
                                       <p>该种质资源为大戟科（Euphobiaceae）橡胶树属，来源巴西亚马逊河，资源种质类型属于野生资源。</p>
                                     </div>
                                  </li>
                                   <li>
                                     <div class="perFirst">
                                         <strong>RO/JP/3 22/52s</strong>
                                         <span>发布时间：2021-06-21</span>
                                     </div>
                                     <div class="perLast">
                                       <p>所在圃库：<span>儋州橡胶树种质资源圃</span></p>
                                       <p>该种质资源为大戟科（Euphobiaceae）橡胶树属，来源巴西亚马逊河，资源种质类型属于野生资源。</p>
                                     </div>
                                  </li>
                                   <li>
                                     <div class="perFirst">
                                         <strong>RO/JP/3 22/52s</strong>
                                         <span>发布时间：2021-06-21</span>
                                     </div>
                                     <div class="perLast">
                                       <p>所在圃库：<span>儋州橡胶树种质资源圃</span></p>
                                       <p>该种质资源为大戟科（Euphobiaceae）橡胶树属，来源巴西亚马逊河，资源种质类型属于野生资源。</p>
                                     </div>
                                  </li>
                                   <li>
                                     <div class="perFirst">
                                         <strong>RO/JP/3 22/52s</strong>
                                         <span>发布时间：2021-06-21</span>
                                     </div>
                                     <div class="perLast">
                                       <p>所在圃库：<span>儋州橡胶树种质资源圃</span></p>
                                       <p>该种质资源为大戟科（Euphobiaceae）橡胶树属，来源巴西亚马逊河，资源种质类型属于野生资源。</p>
                                     </div>
                                  </li>
                               </ul>
                                 <div class="pageNew">
                                  <el-pagination
                                  background
                                  layout="prev, pager, next"
                                  :total="100">
                                  </el-pagination>
                                  <div class="pageIndex">
                                      <span>跳至</span>
                                      <input type="text" placeholder="1">
                                      <span>页</span>
                                  </div>
                                </div>
                            </div>
                        </div>
                    </div>
            </div>
          </div>
        <footer>
            <p>主持单位:中国热带农业科学院热带作物品种资源研究所 | 版权所有©热带作物种质资源信息网</p>
        </footer>
      </div>
  </div>
</template>
<script>
export default {
  name: "zzpList",
  data() {
    return {
     input: '',
    };
  },
  methods: {

  },
};
</script>
<style scoped>
@import "../../assets/scss/show.css";
  .bodyWrap{
    width:100%;
    margin:0 auto;
    background: #eeeeee;
  }
  nav{
     padding:0 18px 16px 18px;
     border: 1px solid #dfe6eb;
    background: #fff;   
     margin-bottom: 10px;
  }
  .content1{
    height: 1570px;
  }
  nav ul li{
    margin-top:16px;
  }
  nav ul li>span{
       font-size: 15px;
    color: #02874a;
    font-weight: 700;
    width: 100px;

    display: inline-block;
    vertical-align: top;
  }
  nav ul li div span{
    font-size: 15px;
    color: #333333;
    margin-right: 27px;
  }
  nav ul li div{
        display: inline-block;
    width: 760px;
  }
  .tabZujian{
    width: 1200px;
    margin: 0 auto;
  }
.pageNew{
    margin:8px auto 0 auto;
    text-align: center;
    padding-bottom: 30px;
  }
  .pageIndex{
    display: inline-block;
    padding: 2px 0;vertical-align: bottom;
  }
  .pageIndex span{
     font-size: 13px;
     color: #606266;
  }
  
  .pageIndex input{
    width: 40px;
    border: 1px solid #dddee1;
    text-align: center;
    font-size: 13px;
    height: 26px;
    line-height: 26px;
    border-radius:3px;
  }
  .rigBox2>h2{
    font-size: 15px;
    color: #333333;
    font-weight: normal;
    margin: 23px 0 10px 0;
  }
   .rigBox2>h2 span{
 color: #02874a;
  }
  .myZy{
    border-radius: 5px;
    background: #fff;margin-top: 26px;
  }
  .perUl li:nth-child(odd){
    background: #e5f3ed;
  }
  .myZy span{
    width: 5px;
    height: 26px;
    background:#fff;
    display: inline-block;
    margin-top: 13.5px;
    float: left;
    margin-right:25px;
  }
  .myZy li{
    font-size: 16px;
    color: #333333;
    border-bottom: 1px solid #02874a;
    height: 53px;
    line-height: 53px;
  }
  .myZy li:last-child{
    border-bottom: 0;
  }
  .myZyHigh{
    background: #02874a;
    color: #fff !important;
  }
  .yidu{
    color: #02874a !important;
  }
  .high{
    background:#e5f3ed;
    border-bottom: 1px solid #e5f3ed;
  }
  .delete{
      display: inline-block;
    margin-right: 27px;
    text-align: right;
    float: right;
  }
  .delete img{
    width: 23px;
    display: block;
  }
  .boxUl li{
    padding: 34px 18px;
  
  }
  .perUl li{
    padding: 20px 18px;
  
  }
  .line{
  border-bottom: 1px solid #80c3a4;
  margin: 0 18px;
  border-left: 1px solid #c8dcdb;
  }
  .divFirst p{
    font-size: 15px;
    display: inline-block;
    color: #333333;
  }
  .divFirst span{
font-size: 13px;
margin: 0 37px;
    color: #999999;
  }
  .divFirst a{
 font-size: 15px;
    color: #e30000;
  }
  .divLast{
    margin-top: 13px;
    display: inline-block;
  }
   .perFirst strong{
    font-size: 15px;
    display: inline-block;
    color: #333333;
  }
   .perFirst span{
    font-size: 15px;
    color: #767877;
    float: right;
  }
  .perLast p{
    font-size: 15px;
    color: #666666;
    margin-top: 4px;
 
  }
  .perLast{
    margin-top:10px;
  }
  .perLast p span{
    color: #02874a;

  }
  .divLast p{
    font-size: 15px;
    color: #666666;
  }
  .personBox{
    background-color: #fff;
     border: 1px solid #dfe6eb;
    border-radius:5px;
    padding:7px 0;
  }
  .saveBtn{
        padding: 70px 0;
    text-align: center;
  }
  .searchBtn{
        display: inline-block;
    float: right;
    background: #02874a;
    height:50px !important;
    width: 120px;
    border-radius: 5px;
    text-align: center;
    
  }
  .searchBtn button{
        background: none;
    height: 50px !important;
    line-height: 50px !important;
    border: none;
    color: #fff;
    font-size: 15px;
  }
 
  .contentRig h1{
    font-size: 16px;;
  color: #484848;
margin: 30px auto 10px auto;

  }
  .el-form-item  span{
    font-size: 15px;
    color: #d67825;
    cursor: pointer;
  }
  .el-form-item a{
    color: #02874a;
    font-size: 15px;
  }

  .ewm{
    margin-top: 26px;
  }
  .ewm img{
    display: block;
    margin:0 auto;
    width: 197px;
  }
   
  .contentLeft{
    width:240px;
    display: inline-block;
    background: #fff;
    padding:20px 10px 15px 10px;
  }
  .contentLeft h2{
    font-size: 18px;
    color: #333333;
    padding-left: 10px;
    margin-bottom: 7px;
  }
  .contentLeft ul li{
font-size: 15px;
    color: #666666; 
    padding: 0 10px;
    border-bottom: 1px dashed #dfdfdf;
    height: 32px;
    line-height: 32px;
  }
  .contentLeft ul li:last-child{
    border-bottom: 0;
  }
  .contentRig{
    width:870px;
     border: 1px solid #dfe6eb;
    background:#fff;
    border-radius: 5px;
    padding:0 20px;
  }
  .rigBox{
     width:910px;
  }
    .rigBox2{
     border: 1px solid #dfe6eb;
    background:#fff;

    padding:0 20px;
  }
  .contentRig dl dt img{
      width:140px;
      display: block;
      margin:50px auto 20px auto;
  }
   .contentRig dl dd p{
    color:#484848;
    font-size: 15px;
    text-align: center;
  }
  .title{
    padding:17px 0;
  }
  .title p{
    font-size: 12px;
    color: #666666;
  }
  footer{
    height: 84px;
    line-height: 84px;
    background: #4a4e53;
    margin-top: 50px;
    text-align: center;
  }
  footer p{
    font-size: 14px;
    color: #fff;
  }
.el-tabs__item{
    font-size: 20px;
    color:#02874a;
  }
  .bottomBox{
    width: 1200px;
     margin: 0 auto;
  }
  .headBottom{
    background:#fff;
    height: 100px;
     
  }
  .headSearch{
    height: 40px;
    margin-top: 30px;
    position: relative;
  }
  .rigBox1{
    height: 50px;
    margin-bottom: 10px;
  }
  .headSearch span{
        background: #02874a;
    position: absolute;
    right: -45px;
    top: 0;
    height: 38px;
    width: 51px;
    border: 1px solid #02874a;
    border-top-right-radius: 5px;
    border-left: 0;
    border-bottom-right-radius: 5px;
  }
  .headSearch span img{
    margin: 0 auto;
    text-align: center;
    display: block;
    margin-top: 7px;
    height: 24px;
  }
  .botLeft img{
   width: 489px;
   height: 42px;
   display: block;
   margin-top:29px;
  }
  .headUl li{
    font-size: 16px;
    color: #333333;
    display: inline-block;
    float: left;
    margin-right: 40px;
    line-height: 100px;
  }
  .topBox{
      width: 1200px;
       margin: 0 auto;
  }
  .headTop{
    background:#f1f1f1;
    height: 30px;
    line-height: 28px;
  }
  .el-input__inner{
    border: 1px solid #02874a !important;
    font-size: 14px;
  }
  .headLeft span{
    font-size: 12px;
    color: #666666;
    display: inline-block;
    margin-right: 30px;
  }
  .headRig span{
    font-size: 12px;
    color: #666666;
    margin-left: 30px;
     display: inline-block;
  }
</style>
